/*
 * Orizza — Footer accordion. Mirrors the reference's mobile footer
 * (https://orizza-m-d-home-vfinal.vercel.app/# — `footer.footer-om`):
 * each of the four mobile rows (Service / Shop / The House / E-Gift Card)
 * is a button + collapsible body, using the same grid-template-rows
 * 0fr → 1fr technique (see section-orizza-footer.css) the reference
 * itself uses for the open/close animation.
 *
 * This markup is shared with desktop (see .orizza-footer__desktop in the
 * CSS, where the headings render as plain non-interactive labels and the
 * link lists are always visible) — the JS below only ever runs against
 * the `[data-orizza-ftr-mobile]` tree, so it never touches the desktop
 * copy of the same links.
 */
(function () {
  function toggleRow(row, open) {
    var button = row.querySelector('[data-orizza-ftr-toggle]');
    row.setAttribute('data-open', open ? 'true' : 'false');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initAccordion(root) {
    var rows = root.querySelectorAll('[data-orizza-ftr-row]');
    if (!rows.length) return;

    rows.forEach(function (row) {
      var button = row.querySelector('[data-orizza-ftr-toggle]');
      if (!button) return;
      button.addEventListener('click', function () {
        var isOpen = row.getAttribute('data-open') === 'true';
        toggleRow(row, !isOpen);
      });
    });
  }

  function setup() {
    document.querySelectorAll('[data-orizza-ftr-mobile]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
